module.exports = __webpack_public_path__ + "static/2.1-25e916d4858851bcf4728ea44a7c1c13.jpg";